import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DokumentApi } from '../../shared/services/api/dokument.api';
import { DefinicjeParametrow } from '../../shared/enums/params-definition.enum';

export const termsAndConditionsResolver: ResolveFn<string> = () => {
  const dokumentApi = inject(DokumentApi);

  return firstValueFrom(
    dokumentApi.getParamContent$(
      DefinicjeParametrow.STRONA_POLITYKA_PRYWATNOSCI,
    ),
  )
    .then((resp) => {
      return resp;
    })
    .catch((_) => {
      return 'Błąd';
    });
};
